import React, { useEffect } from 'react';
import { Box, Field, FlexControlledForm, useDebounceState } from '@common-fe/common-fe';

import usePlansRenewalStore from '@/modules/employer/components/SetupEmployer/Features/PlansRenewal/stores/usePlansRenewal.store';
import FormLoader from '@/modules/employer/components/SetupEmployer/FormLoader';
import { useSetupEmployerMode } from '@/modules/employer/components/SetupEmployer/hooks/useSetupEmployerMode';
import { PlansRenewalValues } from '@/modules/employer/components/SetupEmployer/SetupEmployer.types';
import useGetEmployer from '@/modules/employer/hooks/useGetEmployer.query';

import usePlansRenewalFields from './hooks/usePlansRenewalFields';

const PlansRenewal = () => {
  const { values, setValues } = useDebounceState<PlansRenewalValues>();
  const { setPlansRenewal } = usePlansRenewalStore();
  const { viewMode } = useSetupEmployerMode();
  const { formattedData, isLoading } = useGetEmployer();
  const fields = usePlansRenewalFields({ viewMode, formattedData });

  useEffect(() => {
    setPlansRenewal(values || {});
  }, [values, setPlansRenewal]);
  
  if (isLoading) return <FormLoader testId="PlansRenewal" />;

  return (
    <Box background="canvas" round="container1Round" data-testid="plans-renewal" id="plans_renewal">
      <FlexControlledForm
        formTitle="Plans Renewal"
        fields={fields as Field[]}
        onChangeValues={setValues}
        editMode={!viewMode}
        isThinMode
      />
    </Box>
  );
};

export default PlansRenewal;
